import { EntityState, StoreConfig, EntityStore } from '@datorama/akita';
import { CostCenterOption } from './cost-center-options.model';

export interface CostCenterOptionsUiState {
  corporateAccountId?: string | null;
}

export interface CostCenterOptionsState
  extends EntityState<CostCenterOption, CostCenterOption['id']> {
  ui: CostCenterOptionsUiState;
}

@StoreConfig({ name: 'cost-center-options', resettable: true, idKey: 'id' })
export class CostCenterOptionsStore extends EntityStore<CostCenterOptionsState> {
  constructor() {
    super({ ui: { corporateAccountId: null } });
  }
}

/// This is a singleton store instance to be used across the application.
/// It ensures that the store is initialized only once and can be accessed globally.
/// This is to prevent circular dependencies and to provide a single source of truth for cost center options.
let _store: CostCenterOptionsStore | undefined;
export function getCostCenterOptionsStore(): CostCenterOptionsStore {
  if (!_store) {
    _store = new CostCenterOptionsStore();
  }
  return _store;
}
